import React, { useState } from 'react';

import { Language } from '../../../../interfaces/language.types';

import {
  Container,
  LanguagePosition,
  FlagIcon,
  LanguageLabel,
  LanguageButton,
  LanguagesList,
} from './languageSwitch.styled';
import { LanguageSwitchData } from './languageSwitch.types';

import PlFlag from './images/pl.png';
import DeFlag from './images/de.png';
import RuFlag from './images/ru.png';
import EnFlag from './images/en.png';
import { LanguageSlug } from '../../../../enums/languageSlug.enum';

export const LanguageSwitch: React.FC<LanguageSwitchData> = (data: LanguageSwitchData) => {
  const { languages, currentLanguage, setCurrentLanguage } = data;
  const [isLanguageListVisible, setIsLanguageListVisible] = useState(false);

  const getFlagByLanguageSlug = (languageSlug: LanguageSlug) => {
    switch (languageSlug) {
      case LanguageSlug.Pl:
        return PlFlag;
      case LanguageSlug.De:
        return DeFlag;
      case LanguageSlug.Ru:
        return RuFlag;
      case LanguageSlug.En:
        return EnFlag;
    }
  };

  const changeLanguage = (languageSlug: LanguageSlug): void => {
    setIsLanguageListVisible(false);
    setCurrentLanguage(languageSlug);
  };

  const renderLanguagesListPositions = () => languages.map((language: Language) =>
    <LanguagePosition key={language.id} onClick={() => changeLanguage(language.slug)}>
      <FlagIcon src={getFlagByLanguageSlug(language.slug)} alt={language.name} />
      <LanguageLabel>{language.name}</LanguageLabel>
    </LanguagePosition>
  );

  const toggleLanguageList = () => setIsLanguageListVisible(!isLanguageListVisible);

  return (
    <Container>
      <LanguageButton onClick={() => toggleLanguageList()}>
        <FlagIcon src={getFlagByLanguageSlug(currentLanguage)} alt='' />
      </LanguageButton>
      <LanguagesList isVisible={isLanguageListVisible}>
        {renderLanguagesListPositions()}
      </LanguagesList>
    </Container>
  );
}
